module.exports = __webpack_public_path__ + "img/app-student-new.abaff7d1.png";